/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ValidationResponse } from './validationResponse';

export interface ValidateZipCodeResponse extends ValidationResponse {
  /**
   * flag that determines if the validation is OK
   */
  validInd?: boolean;
  /**
   * Reason why the ZipCode (CAP) is invalid
   */
  reason?: ValidateZipCodeResponse.ReasonEnum;
  /**
   * id of the message to display
   */
  messageID?: string;
}
export namespace ValidateZipCodeResponse {
  export type ReasonEnum = 'INVALID' | 'NO_LONGER_AVAILABLE' | 'NOT_SERVED';
  export const ReasonEnum = {
    INVALID: 'INVALID' as ReasonEnum,
    NOLONGERAVAILABLE: 'NO_LONGER_AVAILABLE' as ReasonEnum,
    NOTSERVED: 'NOT_SERVED' as ReasonEnum,
  };
}
